module.exports = __webpack_public_path__ + "static/media/features_bodega-segura.9025c0f4.jpg";